<template>
  <v-card>
    <v-card-title
      class="headline grey lighten-2" primary-title>
      Новая категория
    </v-card-title>

    <v-card-text>
      <v-text-field label="Категория"
        placeholder="Название категории"
        v-model="currentCategory.caption"
      ></v-text-field>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        @click="cancelEditing"
        color="orange"
        text
      >Отмена</v-btn>
      <v-btn
        @click="saveNote"
        color="primary"
      >Сохранить</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {
  SET_EDITED_CATEGORY_ACTION, SAVE_EDITED_CATEGORY_ACTION,
} from '../store/actions/categories-actions';

export default {
  name: 'EditCategoryDialog',
  data() {
    return {
    };
  },
  computed: {
    currentCategory() {
      return this.$store.getters.categoryForEdit ?? {};
    },
  },
  methods: {
    cancelEditing() {
      this.$store.dispatch(SET_EDITED_CATEGORY_ACTION, undefined);
    },
    saveNote() {
      this.$store.dispatch(SAVE_EDITED_CATEGORY_ACTION, this.currentCategory);
    },
  },
};
</script>

<style scoped>

</style>
